import ModalContainer from 'components/modal/modal-container'

import ModalActions from 'components/modal/modal-actions'
import { Button } from '@mui/material'

import { closeModal } from 'actions/app'
import { assignSelectedClient } from 'actions/client'
import { assignSelectedFarms } from 'actions/farm'

import { deleteFarms } from 'api/farm'
import { useTranslation } from 'react-i18next'

import type { AppState } from 'state/index'
import { useDispatch, useSelector } from 'react-redux'
import { get, find } from 'es-toolkit/compat'
import { useEffect, useState } from 'react'

interface OCFFDeleteFarmProps {
  selectedFarms: {
    id: number | string
    name: string
    clientId: number | string
    fieldCount: number
  }[]
  onSuccess?: () => void
}

export default function OCFFDeleteFarm(props: OCFFDeleteFarmProps) {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const { selectedFarms, onSuccess } = props

  const defaultFarm = useSelector(
    (state) => (state as AppState).account.singleton.prefs?.cff?.farm,
  )

  const [defaultDeletionMsg, showDefaultDeletionMsg] = useState(false)
  const [showArchivedFieldMessage, setShowArchivedFieldMessage] =
    useState(false)

  useEffect(() => {
    if (
      defaultFarm &&
      selectedFarms.find(
        //@ts-expect-error
        (farm) => parseInt(defaultFarm) === parseInt(farm.id),
      )
    ) {
      showDefaultDeletionMsg(true)
    }
  }, [selectedFarms, defaultFarm])

  const closePopup = () => dispatch(closeModal())

  useEffect(() => {
    let _showArchivedFieldMessage = false
    for (
      let i = 0;
      i < selectedFarms.length && !_showArchivedFieldMessage;
      i++
    ) {
      _showArchivedFieldMessage = selectedFarms[i].fieldCount > 0
    }
    setShowArchivedFieldMessage(_showArchivedFieldMessage)
  }, [selectedFarms])

  const deleteItem = () => {
    const defaultClient = localStorage.getItem('selectedClient')
    const clientsToUpdate = {}
    const farmIds = selectedFarms.map((farm) => {
      if (clientsToUpdate[farm.clientId]) {
        clientsToUpdate[farm.clientId].push(farm.id)
      } else {
        clientsToUpdate[farm.clientId] = [farm.id]
      }
      return farm.id
    })
    //@ts-expect-error
    dispatch(
      //@ts-expect-error
      deleteFarms(farmIds, clientsToUpdate, !showArchivedFieldMessage),
    ).then(() => {
      let client
      if (defaultClient) {
        client = JSON.parse(defaultClient)
      }
      if (client && clientsToUpdate[client.id]) {
        const updatedFarms = client['farms'].filter(
          (farm) => !clientsToUpdate[client.id].includes(farm.id),
        )
        localStorage.setItem('selectedFarms', JSON.stringify(updatedFarms))
        client['farms'] = updatedFarms
        localStorage.setItem('selectedClient', JSON.stringify(client))
        dispatch(assignSelectedClient(client))
        dispatch(assignSelectedFarms(updatedFarms))
      }
      if (onSuccess) {
        onSuccess()
      }
    })
  }

  return (
    <ModalContainer>
      {defaultDeletionMsg ? (
        <>
          <div>
            {t('cannot_delete_default', {
              entity: t('farm'),
            })}
          </div>
          <ModalActions>
            <Button variant="contained" color="primary" onClick={closePopup}>
              {t('ok')}
            </Button>
          </ModalActions>
        </>
      ) : showArchivedFieldMessage ? (
        <>
          {selectedFarms.map((farm) => {
            if (farm.fieldCount > 0) {
              return (
                <div key={farm.id}>
                  {t('delete_child_entity_first', {
                    parentEntityName: farm.name,
                    childEntity: t('fields'),
                    parentEntity: t('farm'),
                  })}
                </div>
              )
            }
          })}

          <ModalActions>
            <Button variant="contained" color="primary" onClick={closePopup}>
              {t('ok')}
            </Button>
          </ModalActions>
        </>
      ) : (
        <>
          <div>
            {selectedFarms.length > 1
              ? t('delete_multiple_item_warning', {
                  count: selectedFarms.length,
                  item: t('farms'),
                })
              : t('delete_item_warning', { name: selectedFarms[0].name })}
            <br />
            {t('delete_cannot_be_undone')}
          </div>
          <br />
          <ModalActions>
            <Button variant="contained" color="secondary" onClick={closePopup}>
              {t('cancel')}
            </Button>
            <Button variant="contained" color="primary" onClick={deleteItem}>
              {t('delete')}
            </Button>
          </ModalActions>
        </>
      )}
    </ModalContainer>
  )
}
